import { useSelector, useDispatch } from 'react-redux'

import { PERIODS_2 } from 'Constants';
import renderingGuide from 'Component/title/guide_content';
import Radio from 'Component/common/radio';
import GraphHowto from 'Component/graph/howto';
import { setType, setHowto } from 'Reducers/stock'
import SubHead from 'Component/title/sub_head';

const Howto = () => {

  const { tickerDetail, howto, type } = useSelector((state) => state.stock);
  const dispatch = useDispatch();

  function changeType(item) {
    dispatch(setHowto({}));
    setTimeout(() => {
      dispatch(setType(item));
    }, 200);
  }

  function checked(item) {
    return type && item.value === type.value;
  }

	return (
    <div className="content6">
      <SubHead guideType="stock" guide="hotwo">
        <img src="/static/images/icon_dollar4.png" alt="" />
        <span>토브스탁 Trading Range</span>
      </SubHead>
      <div className="howto chartarea card type3">
        <Radio radios={PERIODS_2} selected={type} onChange={changeType} checked={checked} />
        { howto
          ?
          <GraphHowto ctrTyp={tickerDetail.CTR_TYP} data={howto} />
          :
          <div className="chart chart1 chart_none">
            <div className="none_ico"><img src="/static/images/icon_ai.svg" alt="" /></div>
            <div className="none_txt txt_gray">AI 데이터 학습 중입니다.</div>
          </div>
        }
        <div className="tip">* 매매(Trading)전략 : 돌파하면 보유, 하락하면 매도.</div>

        {/* 설명: 같은 카드 내부 맨 아래에 연한 회색 구분선과 번호형 설명 추가 */}
        <div style={{marginTop:14}}>
          <div style={{borderTop: '1px solid #eee'}} />
          <div style={{marginTop:12, color:'#666', lineHeight:1.8}}>
            <div style={{fontWeight:700,color:'#333', marginBottom:0, fontSize:16}}>Trading Range</div>
            <div style={{fontWeight:600, fontSize:14}}>※ 피보나치, 카마릴라 등 과학적 방법론을 적용해 감정을 배제하고 지지와 저항을 분석합니다.</div>
            <div style={{fontWeight:600, fontSize:14}}>※ 주가가 저항값을 상향 돌파하면 보유, 지지값을 하향 돌파하면 손절을 고려하며, 반대로 지지값에서 반등 시 매수, 저항값에서 반락 시 매도하는 전략이 유효합니다.</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Howto;
